import { prop } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getSubsellers = createSelector(getRoot, (subsellers) => subsellers && subsellers.results);
